export const MATERIAL_COMPARISON_DESCRIPTION =
  'Compare material properties and machining behavior. See how Vc, fz, ap and ae should change when switching materials. Cutting-condition comparison is currently focused on solid carbide end mills.';

export const materialTools = [
  {
    title: 'Material Database',
    description: 'Find a known material and view its properties and machining information.',
    cta: 'Browse materials',
    to: '/materials/listofmaterials',
  },
  {
    title: 'Material Finder',
    description: 'Enter the properties you know and find materials that match them.',
    cta: 'Find a material',
    to: '/materials/materialfinder',
  },
  {
    title: 'Material Comparison',
    description: MATERIAL_COMPARISON_DESCRIPTION,
    cta: 'Compare materials',
    to: '/materials/materialcomparison',
  },
];

export const getMaterialComparisonUrl = (side, slug) =>
  `/materials/materialcomparison?${side}=${encodeURIComponent(slug)}`;
